import { useState, useCallback } from 'react'
import { toast } from 'react-toastify'
import { useMutation, useQueryClient } from 'react-query'

import { updateVouchersStatusAPI } from 'api/vouchers'
import { useVouchersStore } from 'store/vouchers'

import {
  VouchersDataTypes,
  UpdateVouchersStatusFormTypes,
} from 'types/vouchers'

import { DATASTATUS } from 'constants/status'

export const useMemberVouchersStatusUpdate = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: VouchersDataTypes
}) => {

  const vouchersStatusUpdateModStatusSet = useVouchersStore(
    (state) => state.vouchersStatusUpdateModStatusSet
  )

  const [
    vouchersStatusUpdateParams,
    vouchersStatusUpdateParamsSet,
  ] = useState<UpdateVouchersStatusFormTypes>({
    voucherId: selectedRowData.voucherId,
    voucherTenderId: selectedRowData.voucherTenderId,
    voucherStatusId: 1,
  })

  const queryClient = useQueryClient()
  const { mutateAsync } = useMutation({
    mutationFn: updateVouchersStatusAPI,
    mutationKey: 'updateVouchersStatusUpdate',
    onMutate: (values) => {
      vouchersStatusUpdateModStatusSet('loading')
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: ['useVouchers'],
      })
      vouchersStatusUpdateModStatusSet('success')
    },
    onError: (error) => {
      vouchersStatusUpdateModStatusSet('fail')
    },
  })

  const handleStatusUpdate = useCallback(
    async (mergeParams: UpdateVouchersStatusFormTypes) => {
      try {
        const response = await mutateAsync({
          ...vouchersStatusUpdateParams,
          ...mergeParams,
        })
        if (response.outcomeCode !== '0') throw response
        toast.success('Voucher status update successful.')
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`Voucher status update error: ${message.outcomeUserMessage || message.outcomeMessage}`)
      } finally {
        modalClose()
      }
    },
    [mutateAsync, vouchersStatusUpdateParams, modalClose]
  )

  return {
    memberVouchersStatusUpdateParams: vouchersStatusUpdateParams,
    memberHandleVouchersStatusUpdate: handleStatusUpdate,
  }
}
